import { Skeleton } from './Skeleton';

/**
 * Circular skeleton component for avatars and circular images.
 */
export interface SkeletonCircleProps {
  size?: string;
  className?: string;
}

export const SkeletonCircle = ({ size = 'w-12 h-12', className = '' }: SkeletonCircleProps) => {
  return <Skeleton className={`${size} rounded-full ${className}`} />;
};
